import {Fragment} from "react";
import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {KM_HM_TEST_IDS} from "@pg-mono/test-ids";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchPreferencesWizardSurveyForm} from "../../utils/get_home_match_preferences_wizard_step_patch";
import {HomeMatchPreferencesWizardStep, HomeMatchPreferencesWizardSurveyStep} from "../../utils/get_home_match_preferences_wizard_steps";
import {
    getApartmentLabel,
    getBudgetLabel,
    getLocationLabel,
    getSummaryPropertyLabel,
    IHomeMatchPreferencesWizardSummaryData
} from "../../utils/get_home_match_preferences_wizard_summary_labels";
import {HomeMatchPreferencesWizardSummaryConsent} from "./HomeMatchPreferencesWizardSummaryConsent";
import {HomeMatchPreferencesWizardSummaryRow, IHomeMatchPreferencesWizardSummaryRowProps} from "./HomeMatchPreferencesWizardSummaryRow";

const {SUMMARY} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IProps {
    consent: boolean;
    onChangeProperty: () => void;
    onChangeStep: (step: HomeMatchPreferencesWizardSurveyStep) => void;
    onConsentChange: (consent: boolean) => void;
    summary: IHomeMatchPreferencesWizardSummaryData;
}

export const HomeMatchPreferencesWizardSummaryStep = (props: IProps) => {
    const {consent, onChangeProperty, onChangeStep, onConsentChange, summary} = props;
    const {price, regionDetails, regionIds, regionOptions} = summary;
    const {watch} = useFormContextRHF<IHomeMatchPreferencesWizardSurveyForm>();
    const financing = watch("financing");
    const {BUDGET, LOCATION} = HomeMatchPreferencesWizardStep;
    const preferenceRows: IHomeMatchPreferencesWizardSummaryRowProps[] = [
        {
            label: SUMMARY.LOCATION,
            onChange: () => onChangeStep(LOCATION),
            overflow: "ellipsis",
            testId: KM_HM_TEST_IDS.PREFERENCES_WIZARD_SUMMARY_LOCATION,
            value: getLocationLabel(regionIds, regionOptions, regionDetails)
        },
        {
            label: SUMMARY.BUDGET,
            onChange: () => onChangeStep(BUDGET),
            testId: KM_HM_TEST_IDS.PREFERENCES_WIZARD_SUMMARY_BUDGET,
            value: getBudgetLabel(price, financing)
        },
        {
            label: getSummaryPropertyLabel(summary.types),
            onChange: onChangeProperty,
            overflow: "pingpong",
            testId: KM_HM_TEST_IDS.PREFERENCES_WIZARD_SUMMARY_SIZE,
            value: getApartmentLabel(summary)
        }
    ];

    return (
        <div className={stepStyle}>
            <div className={preferencesCardStyle}>
                {preferenceRows.map((row, index) => (
                    <Fragment key={row.testId}>
                        {index > 0 && <div className={dividerStyle} />}

                        <HomeMatchPreferencesWizardSummaryRow {...row} />
                    </Fragment>
                ))}
            </div>

            <HomeMatchPreferencesWizardSummaryConsent consent={consent} onConsentChange={onConsentChange} />
        </div>
    );
};

const stepStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    mb: "2.1rem",

    md: {
        mb: 0
    }
});

const preferencesCardStyle = css({
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    p: 2
});

const dividerStyle = css({
    backgroundColor: "var(--colors-gray-300)",
    height: "1px"
});
import {Fragment} from "react";
import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {KM_HM_TEST_IDS} from "@pg-mono/test-ids";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchPreferencesWizardSurveyForm} from "../../utils/get_home_match_preferences_wizard_step_patch";
import {HomeMatchPreferencesWizardStep, HomeMatchPreferencesWizardSurveyStep} from "../../utils/get_home_match_preferences_wizard_steps";
import {
    getApartmentLabel,
    getBudgetLabel,
    getLocationLabel,
    getSummaryPropertyLabel,
    IHomeMatchPreferencesWizardSummaryData
} from "../../utils/get_home_match_preferences_wizard_summary_labels";
import {HomeMatchPreferencesWizardSummaryConsent} from "./HomeMatchPreferencesWizardSummaryConsent";
import {HomeMatchPreferencesWizardSummaryRow, IHomeMatchPreferencesWizardSummaryRowProps} from "./HomeMatchPreferencesWizardSummaryRow";

const {SUMMARY} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IProps {
    consent: boolean;
    onChangeProperty: () => void;
    onChangeStep: (step: HomeMatchPreferencesWizardSurveyStep) => void;
    onConsentChange: (consent: boolean) => void;
    summary: IHomeMatchPreferencesWizardSummaryData;
}

export const HomeMatchPreferencesWizardSummaryStep = (props: IProps) => {
    const {consent, onChangeProperty, onChangeStep, onConsentChange, summary} = props;
    const {price, regionDetails, regionIds, regionOptions} = summary;
    const {watch} = useFormContextRHF<IHomeMatchPreferencesWizardSurveyForm>();
    const financing = watch("financing");
    const {BUDGET, LOCATION} = HomeMatchPreferencesWizardStep;
    const preferenceRows: IHomeMatchPreferencesWizardSummaryRowProps[] = [
        {
            label: SUMMARY.LOCATION,
            onChange: () => onChangeStep(LOCATION),
            overflow: "ellipsis",
            testId: KM_HM_TEST_IDS.PREFERENCES_WIZARD_SUMMARY_LOCATION,
            value: getLocationLabel(regionIds, regionOptions, regionDetails)
        },
        {
            label: SUMMARY.BUDGET,
            onChange: () => onChangeStep(BUDGET),
            testId: KM_HM_TEST_IDS.PREFERENCES_WIZARD_SUMMARY_BUDGET,
            value: getBudgetLabel(price, financing)
        },
        {
            label: getSummaryPropertyLabel(summary.types),
            onChange: onChangeProperty,
            overflow: "pingpong",
            testId: KM_HM_TEST_IDS.PREFERENCES_WIZARD_SUMMARY_SIZE,
            value: getApartmentLabel(summary)
        }
    ];

    return (
        <div className={stepStyle}>
            <div className={preferencesCardStyle}>
                {preferenceRows.map((row, index) => (
                    <Fragment key={row.testId}>
                        {index > 0 && <div className={dividerStyle} />}

                        <HomeMatchPreferencesWizardSummaryRow {...row} />
                    </Fragment>
                ))}
            </div>

            <HomeMatchPreferencesWizardSummaryConsent consent={consent} onConsentChange={onConsentChange} />
        </div>
    );
};

const stepStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    mb: "2.1rem",

    md: {
        mb: 0
    }
});

const preferencesCardStyle = css({
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    p: 2
});

const dividerStyle = css({
    backgroundColor: "var(--colors-gray-300)",
    height: "1px"
});
